import { render, staticRenderFns } from "./SocialUpload.vue?vue&type=template&id=57b54a69"
import script from "./SocialUpload.vue?vue&type=script&lang=js"
export * from "./SocialUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports